
import { ArticleItem } from '@/components/article'
import i18n from '@/i18n'
import Vue from 'vue'

export default Vue.extend({
    metaInfo() {
        return {
            title: "Tailor | BOBU AFRICA",
            link: [
                { rel: "canonical", href: `${window.location.href}` }
            ],
            meta: [
                { name: 'description', content: 'Tailor | BOBU AFRICA' },
                { property: "og:type", content: "website" },
                { property: "og:url", content: `${window.location.href}` },
                { property: "og:title", content: "Tailor | BOBU AFRICA" },
                { property: "og:description", content: "Tailor | BOBU AFRICA" },
                { property: "og:image", content: "https://static.bobuafrica.com/loading.webp" },

                { property: "twitter:card", content: "summary_large_image" },
                { property: "twitter:url", content: `${window.location.href}` },
                { property: "twitter:title", content: "Tailor | BOBU AFRICA" },
                { property: "twitter:description", content: "Tailor | BOBU AFRICA" },
                { property: "twitter:image", content: "https://static.bobuafrica.com/loading.webp" },

            ]
        }
    },
    components: { ArticleItem },
    data() {
        return {
            article: []
        }
    },
    async mounted() {
        try {
            const response = await this.$axios.get(`/article?fields=*,translations.*&filter[type][_eq]=tailor_made&deep[translations][_filter][languages_code][_eq]=${i18n.locale}`)
            this.article = response.data

            console.log(response)
        } catch (error) {
            console.error('Error fetching term data:', error)
        }
    }
})
